import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';

/**
 * 
 * @param {object} props.items
 * @param {object} props.items.contents[i]
 * @param {string || React component} props.items.contents[i].desc
 * @param {string || React component} props.items.contents[i].title
 * @param {React component} props.items.contents[i].icon
 */
const InformationCard = (props) => {

  return(
    <div css={css`
      width: 100%;
      min-height: 400px;
      padding: 20px;
      box-shadow: 0 1px 4px rgba(0,0,0,0.2);
    `}>
      {
        props.items.map((item, index)=>{

          if(item.title){
            return(
              <div key={index}
                css={css`
                  font-size: 1.0rem;
                  font-weight: 600;
                  padding: 10px 0;
                `}
              >{item.title}</div>
            )
          }else{
            return(
              <div key={index}
                css={css`
                  width: 98%;
                `}>
              {
                item.contents.map((content, i)=>{
                  return(
                    <div key={i}
                      css={css`
                        width: 100%;
                        padding: 10px 0;
                      `}
                    >
                      <div><span css={css`padding: 0 10px 0 0;`}>{content.icon}</span><i>{content.title}</i></div>
                      <div>{content.desc}</div>
                    </div>
                  )
                })
              }
              </div>
            )
          }
        })
      }
    </div>
  )
}

export default InformationCard;

InformationCard.defaultProps = {
  items: [
    
  ]
}